(() => {
  angular
    .module('complianceFrameworkApp.core')
    .filter('capitalize', capitalize);

  function capitalize() {
    return input => {
      if (input != null) {
        input = input.toLowerCase();
        return `${input.substring(0, 1).toUpperCase()}${input.substring(1)}`;
      }
    };
  }
})();
